export const THREE_D = 'ThreeD';

export const CREDIT_CARD_TYPE = 'scheme';
export const ADYEN_CC = 'adyen_cc';
